import React from 'react';
import { Style } from 'radium';

import PrefixerRadium from 'components/PrefixerRadium';
import { defaultTextStyle, colors } from 'settings/theme';
import { getLocalizedText } from '@vp-dst/localization-util';

function TimezoneSelect(props) {
    const {
        selectedTimezone,
        timezones,
        timezoneOnChange,
    } = props;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <label
                htmlFor={'timezone-select'}
                style={{
                    ...defaultTextStyle,
                    fontSize: '1.2em',
                }}
            >
                {getLocalizedText('current-timezone')}
            </label>
            <Style // adds a style tag with the given css rules
                rules={{
                    '#timezone-select::-ms-expand': { // remove default arrow on ie11
                        display: 'none',
                    },
                }}
            />
            <select
                id={'timezone-select'}
                name="form-timezone"
                value={selectedTimezone}
                onChange={event => timezoneOnChange(event.target.value)}
                style={{
                    ...defaultTextStyle,
                    fontSize: '1.2em',

                    // overwrite default <select/> styles
                    width: 'unset',
                    height: 'unset',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderRight: 'none',
                    backgroundColor: colors.background,
                    borderBottom: '1px solid black',
                    borderRadius: 0,
                    appearance: 'none',
                    paddingLeft: 4,
                    paddingRight: 16, // make room for the down arrow
                }}
            >
                <option value="" disabled selected></option>
                {timezones.map(tz => (<option key={`timezone-option-${tz.value}`} value={tz.value}>{tz.text}</option>))}
            </select>
            <span
                className="graphic-button graphic-button-arrow-d graphic-button-skin-black"
                style={{
                    // fudge the arrow closer to the dropdown
                    position: 'relative',
                    left: -18,

                    // allow click to "pass through" the icon in order to activate the dropdown
                    pointerEvents: 'none',
                }}
            />
        </div>
    );
}

export default PrefixerRadium(TimezoneSelect);



// WEBPACK FOOTER //
// ./src/components/Scheduler/TimezoneSelect.js